import { combineReducers } from 'redux'
//import { persistReducer } from 'redux-persist'

//import { reducer as formReducer } from 'redux-form'
import qrHandler from '../components/home/qrHandler/qrHandlerRedux'
import tagHandler from '../components/tag/tagHandlerRedux'
import stickerHandler from '../components/sticker/stickerHandlerRedux'
import bundleHandler from '../components/bundle-memento/bundleHandlerRedux'
import nodeHandler from '../components/node/nodeHandlerRedux'
import userHandler from '../components/user/userHandlerRedux'
import notificationHandler from '../components/handlers/notification/notificationHandlerRedux'
import onboardingHandler from '../components/handlers/onboarding/onboardingHandler'

/*const persistConfig = {
	key: 'root', // key is required
	storage: sessionStorage, // storage is now required
};*/

const reducers = combineReducers({
	//form: formReducer, // Redux Form
	qrHandler,
	tagHandler,
	stickerHandler,
	bundleHandler,
	nodeHandler,
	userHandler,
	notificationHandler,
	onboardingHandler
});

export default reducers;//persistReducer(persistConfig, reducers);


// WEBPACK FOOTER //
// ./src/redux/reducers.js